/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";

import * as Yup from "yup";
import { FormikProvider, useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import DropZoneImage from "../../Common/Components/Dropzone";
import { doGetProjectSetting, doPatchProjectSetting } from "../../services/project.service";
import { doFileUpload } from "../../services/file.service";
import { OperatingHours } from "../../Common/Components/OperatingHours";
import ReactQuill from "react-quill";

const Setting = () => {
  const [coverImageFiles, setCoverImageFiles] = useState<Array<any>>([]);
  const [logoImageFiles, setLogoImageFiles] = useState<Array<any>>([]);
  const [data, setData] = useState<any>();

  // const project = JSON.parse(localStorage.getItem("authProject") as string) as Project;

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      projectSettingId: (data && data.projectSettingId) || '',
      coverImage: (data && data.coverImage) || [],
      coverImageFiles: (data && data.coverImageFiles) || [],
      logoImage: (data && data.logoImage) || [],
      logoImageFiles: (data && data.logoImageFiles) || [],
      motto: (data && data.motto) || '',
      welcomeMessage: (data && data.welcomeMessage) || '',
      address: (data && data.address) || '',
      addressLink: (data && data.addressLink) || '',
      contactNo: (data && data.contactNo) || '',
      contactEmail: (data && data.contactEmail) || '',
      operationHours: (data && data.operationHours) || '',
      operationDays: (data && data.operationDays) || '',
      operationDaysOnsite: (data && data.operationDaysOnsite) || '',
      operationHoursOnsite: (data && data.operationHoursOnsite) || '',
      operation: (data && data.operation) || {
        offsite: {
          interval: (data && data.operation?.offsite?.interval) || '',
          hours: (data && data.operation?.offsite?.hours) || [],
        },
        onsite: {
          interval: (data && data.operation?.onsite?.interval) || '',
          hours: (data && data.operation?.onsite?.hours) || [],
        },
      },
      themeColor: (data && data.themeColor) || '',
      buttonColor: (data && data.buttonColor) || '',
      serviceColor: (data && data.serviceColor) || '',
      offsiteName: (data && data.offsiteName) || '',
      externalName: (data && data.externalName) || '',
      allowExternalBooking: (data && data.allowExternalBooking) || false,
      allowOffsiteBooking: (data && data.allowOffsiteBooking) || true,
      allowCustomerLogin: (data && data.allowCustomerLogin) || false,
      commissionPercentage: (data && data.commissionPercentage) || '',
      metadata: (data && data.metadata) || {},
    },
    validationSchema: Yup.object({
      projectSettingId: Yup.string().optional().nullable(),
      coverImage: Yup.array().of(Yup.string()).optional().nullable(),
      logoImage: Yup.array().of(Yup.string()).optional().nullable(),
      motto: Yup.string().optional().nullable(),
      welcomeMessage: Yup.string().optional().nullable(),
      address: Yup.string().optional().nullable(),
      addressLink: Yup.string().optional().nullable(),
      contactNo: Yup.string().optional().nullable(),
      contactEmail: Yup.string().optional().nullable(),
      operationHours: Yup.string().optional().nullable(),
      operationDays: Yup.string().optional().nullable(),
      operationDaysOnsite: Yup.string().optional().nullable(),
      operationHoursOnsite: Yup.string().optional().nullable(),
      operation: Yup.object().optional().nullable(),
      themeColor: Yup.string().optional().nullable(),
      buttonColor: Yup.string().optional().nullable(),
      serviceColor: Yup.string().optional().nullable(),
      offsiteName: Yup.string().optional().nullable(),
      externalName: Yup.string().optional().nullable(),
      allowOffsiteBooking: Yup.boolean().default(true),
      allowExternalBooking: Yup.boolean().default(false),
      allowCustomerLogin: Yup.boolean().default(false),
      commissionPercentage: Yup.string().optional().nullable(),
      metadata: Yup.object().optional().nullable(),
    }),

    onSubmit: async (values) => {
      const coverImages = []
      if (coverImageFiles.length > 0) {
        for (const file of coverImageFiles) {
          const fileObject = await doFileUpload(file.name, file.base64)
          coverImages.push(fileObject.fileId)
        }
        values.coverImage = coverImages[0]
      }

      const logoImages = []
      if (logoImageFiles.length > 0) {
        for (const file of logoImageFiles) {
          const fileObject = await doFileUpload(file.name, file.base64)
          logoImages.push(fileObject.fileId)
        }
        values.logoImage = logoImages[0]
      }

      const data = {
        ...values,
      };

      doPatchProjectSetting(data).then((res: any) => {
        toast.success('Project setting updated successfully', { autoClose: 2000 })
      }).catch((error) => {
        console.log(error)
      })
    },
  })

  useEffect(() => {
    doGetProjectSetting().then((res: any) => {
      setData(res)
      validation.setValues({
        ...res,
      })
    })
  }, [])

  return (
    <React.Fragment>
      <BreadCrumb title={'Setting'} pageTitle='Setting' pageTitleLink="/setting" />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card scroll">
            <div id="card-body" className="!pb-32 card-body">
              <FormikProvider value={validation}>
                <form action="#!" onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}>
                  <div className="inline-flex items-center justify-center w-full relative">
                    <hr className="w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                    <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-white">
                      General
                    </span>
                  </div>
                  <div className="grid grid-cols-3 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                    <div className="xl:col-span-6">
                      <div className="flex items-center gap-3">
                        <label
                          htmlFor={`allowCustomerLoginOption`}
                          className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700">
                          <span className="grow flex items-center gap-3">
                            <input id={`allowCustomerLoginOption`}
                              className="w-4 h-4 border appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                              type="checkbox"
                              name="allowCustomerLogin"
                              checked={validation.values.allowCustomerLogin}
                              onChange={validation.handleChange} />
                            <span className="block font-semibold text-15">Allow Customer Login</span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-6">
                      <label htmlFor="coverImage" className="inline-block mb-2 text-base font-medium">Cover Image</label>
                      <DropZoneImage
                        selectfiles={coverImageFiles}
                        setSelectfiles={setCoverImageFiles}
                        formikData={validation}
                        fieldName='coverImage'
                        files={validation.values.coverImageFiles}
                        maxFiles={1}
                      />
                    </div>
                    <div className="xl:col-span-6">
                      <label htmlFor="logoImage" className="inline-block mb-2 text-base font-medium">Logo</label>
                      <DropZoneImage
                        selectfiles={logoImageFiles}
                        setSelectfiles={setLogoImageFiles}
                        formikData={validation}
                        fieldName='logoImage'
                        files={validation.values.logoImageFiles}
                        maxFiles={1}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-6">
                      <label htmlFor="motto" className="inline-block mb-2 text-base font-medium">Motto</label>
                      <input id="motto" name="motto" placeholder="Motto" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.motto || ""}
                      />
                    </div>
                    <div className="xl:col-span-6">
                      <label htmlFor="welcomeMessage" className="inline-block mb-2 text-base font-medium">Welcome Message</label>
                      <input id="welcomeMessage" name="welcomeMessage" placeholder="Welcome Message" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.welcomeMessage || ""}
                      ></input>
                    </div>
                  </div>
                  <div className="inline-flex items-center justify-center w-full relative">
                    <hr className="w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                    <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-white">
                      Information
                    </span>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-12">
                      <label htmlFor="address" className="inline-block mb-2 text-base font-medium">Address</label>
                      <textarea id="address" name="address" placeholder="Address" rows={3} className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.address || ""}
                      ></textarea>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-12">
                      <label htmlFor="addressLink" className="inline-block mb-2 text-base font-medium">Address Link</label>
                      <input type="text" id="addressLink" name="addressLink" placeholder="Address Link" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.addressLink || ""}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-6">
                      <label htmlFor="contactNo" className="inline-block mb-2 text-base font-medium">Contact No</label>
                      <input type="text" id="contactNo" name="contactNo" placeholder="Contact No" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.contactNo || ""}
                      />
                    </div>
                    <div className="xl:col-span-6">
                      <label htmlFor="contactEmail" className="inline-block mb-2 text-base font-medium">Contact Email</label>
                      <input type="text" id="contactEmail" name="contactEmail" placeholder="Contact Email" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.contactEmail || ""}
                      />
                    </div>
                  </div>
                  <div className="inline-flex items-center justify-center w-full relative">
                    <hr className="w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                    <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-white">
                      Color
                    </span>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-4 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-2">
                      <label htmlFor="themeColor" className="inline-block mb-2 text-base font-medium">Theme Color</label>
                      <input type="color" id="themeColor" name="themeColor" placeholder="Theme Color"
                        className="block w-12 h-12"
                        onChange={validation.handleChange}
                        value={validation.values.themeColor || ""}
                      />
                    </div>
                    <div className="xl:col-span-2">
                      <label htmlFor="buttonColor" className="inline-block mb-2 text-base font-medium">Button Color</label>
                      <input type="color" id="buttonColor" name="buttonColor" placeholder="Button Color"
                        className="block w-12 h-12"
                        onChange={validation.handleChange}
                        value={validation.values.buttonColor || ""}
                      />
                    </div>
                    <div className="xl:col-span-2">
                      <label htmlFor="serviceColor" className="inline-block mb-2 text-base font-medium">Service Color</label>
                      <input type="color" id="serviceColor" name="serviceColor" placeholder="Service Color"
                        className="block w-12 h-12"
                        onChange={validation.handleChange}
                        value={validation.values.serviceColor || ""}
                      />
                    </div>
                  </div>
                  <div className="inline-flex items-center justify-center w-full relative">
                    <hr className="w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                    <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-white">
                      Form
                    </span>
                  </div>
                  <div className="grid grid-cols-3 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="xl:col-span-6">
                      <div className="flex items-center gap-3">
                        <label
                          htmlFor={`allowOffsiteBookingOption`}
                          className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700">
                          <span className="grow flex items-center gap-3">
                            <input id={`allowOffsiteBookingOption`}
                              className="w-4 h-4 border appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                              type="checkbox"
                              name="allowOffsiteBooking"
                              checked={validation.values.allowOffsiteBooking}
                              onChange={validation.handleChange} />
                            <span className="block font-semibold text-15">Allow Offsite Booking</span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="xl:col-span-6">
                      <div className="flex items-center gap-3">
                        <label
                          htmlFor={`allowExternalBookingOption`}
                          className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700">
                          <span className="grow flex items-center gap-3">
                            <input id={`allowExternalBookingOption`}
                              className="w-4 h-4 border appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                              type="checkbox"
                              name="allowExternalBooking"
                              checked={validation.values.allowExternalBooking}
                              onChange={validation.handleChange} />
                            <span className="block font-semibold text-15">Allow Onsite Booking</span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="col-span-6">
                      <label htmlFor="offsiteName" className="inline-block mb-2 text-base font-medium">Offsite Label Name</label>
                      <input type="text" id="offsiteName" name="offsiteName" placeholder="Offsite Label Name" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.offsiteName || ""}
                      />
                    </div>
                    <div className="col-span-6">
                      <label htmlFor="externalName" className="inline-block mb-2 text-base font-medium">Onsite Label Name</label>
                      <input type="text" id="externalName" name="externalName" placeholder="External Label Name" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.externalName || ""}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="col-span-6">
                      <label htmlFor="operation.offsite.interval" className="inline-block mb-2 text-base font-medium">Offsite Operation Interval</label>
                      <input type="text" id="operation.offsite.interval" name="operation.offsite.interval" placeholder="Operation Interval" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.operation?.offsite?.interval}
                      />
                    </div>
                    <div className="col-span-6">
                      <label htmlFor="operation.onsite.interval" className="inline-block mb-2 text-base font-medium">Onsite Operation Interval</label>
                      <input type="text" id="operation.onsite.interval" name="operation.onsite.interval" placeholder="Operation Interval" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        onChange={validation.handleChange}
                        value={validation.values.operation?.onsite?.interval}
                      />
                    </div>
                  </div>
                  <OperatingHours formik={validation} types={[{ key: 'offsite', label: 'Offsite Schedule' }, { key: 'onsite', label: 'Onsite Schedule' }]} />
                  <div className="inline-flex items-center justify-center w-full relative">
                    <hr className="w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                    <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-white">
                      Others
                    </span>
                  </div>
                  <div className="grid grid-cols-3 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="col-span-3">
                      <label htmlFor="commissionPercentageInput" className="inline-block mb-2 text-base font-medium">Booking Commission (%)</label>
                      <input
                        type="text"
                        id="commissionPercentageInput"
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        placeholder="10"
                        name="commissionPercentage"
                        onChange={validation.handleChange}
                        value={validation.values.commissionPercentage || ""}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="col-span-12">
                      <label htmlFor="metadata.invoiceNotes" className="inline-block mb-2 text-base font-medium">Invoice Notes</label>
                      <ReactQuill
                        id={`metadata.invoiceNotes`}
                        placeholder="Invoice Notes"
                        className="w-full border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        theme="snow"
                        value={validation.values.metadata?.invoiceNotes || ""}
                        onChange={(value) => {
                          validation.setFieldValue(`metadata.invoiceNotes`, value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="col-span-12">
                      <label htmlFor="metadata.whatsappNewOrderNotification" className="inline-block mb-2 text-base font-medium">Whatsapp New Order Notification</label>
                      <ReactQuill
                        id={`metadata.whatsappNewOrderNotification`}
                        placeholder="Whatsapp New Order Notification"
                        className="w-full border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        theme="snow"
                        value={validation.values.metadata?.whatsappNewOrderNotification || ""}
                        onChange={(value) => {
                          validation.setFieldValue(`metadata.whatsappNewOrderNotification`, value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12 mt-4">
                    <div className="col-span-12">
                      <label htmlFor="metadata.whatsappReadyNotification" className="inline-block mb-2 text-base font-medium">Whatsapp Ready Notification</label>
                      <ReactQuill
                        id={`metadata.whatsappReadyNotification`}
                        placeholder="Whatsapp Ready Notification"
                        className="w-full border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        theme="snow"
                        value={validation.values.metadata?.whatsappReadyNotification || ""}
                        onChange={(value) => {
                          validation.setFieldValue(`metadata.whatsappReadyNotification`, value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="inline-flex items-center justify-center w-full relative">
                    <hr className="w-full h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                  </div>
                  <div className="flex justify-end gap-2 mt-4">
                    <button type="submit" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                      {'Save'}
                    </button>
                  </div>
                </form>
              </FormikProvider>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Setting;